<script setup lang="ts">
  import { ref } from 'vue';
  import { FilePlus, FolderPlus, ListPlus, Plus } from 'lucide-vue-next';
  import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui';
  import {
    configureAddButtonClass,
    configureAddIconFrameClass,
  } from './directoriesPermissions.styles';

  const props = withDefaults(
    defineProps<{
      canAddDocument?: boolean;
    }>(),
    {
      canAddDocument: true,
    }
  );

  const emit = defineEmits<{
    (e: 'create-folder'): void;
    (e: 'add-record'): void;
    (e: 'add-document'): void;
  }>();

  const isOpen = ref(false);

  const handleCreateFolder = () => {
    isOpen.value = false;
    emit('create-folder');
  };

  // The modal opens right away and loads its own first page, so there is nothing to wait for
  // here: the menu closes on the click, like the other two items.
  const handleAddRecord = () => {
    isOpen.value = false;
    emit('add-record');
  };

  const handleAddDocument = () => {
    isOpen.value = false;
    emit('add-document');
  };
</script>

<template>
  <Popover v-model:open="isOpen">
    <PopoverTrigger as-child>
      <button type="button" :class="configureAddButtonClass" aria-label="Adicionar">
        <span :class="configureAddIconFrameClass">
          <Plus class="size-3.5" />
        </span>
      </button>
    </PopoverTrigger>
    <PopoverContent
      data-testid="directories-add-menu-content"
      side="top"
      align="end"
      class="flex w-60 flex-col gap-1 p-1"
    >
      <button
        v-if="props.canAddDocument"
        type="button"
        data-testid="add-menu-add-document"
        class="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-gray-07 hover:bg-gray-01"
        @click="handleAddDocument"
      >
        <FilePlus class="size-4 shrink-0" />
        Adicionar Documento
      </button>
      <button
        type="button"
        data-testid="add-menu-add-record"
        class="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-gray-07 hover:bg-gray-01"
        @click="handleAddRecord"
      >
        <ListPlus class="size-4 shrink-0" />
        Adicionar Registro
      </button>
      <button
        type="button"
        data-testid="add-menu-create-folder"
        class="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-gray-07 hover:bg-gray-01"
        @click="handleCreateFolder"
      >
        <FolderPlus class="size-4 shrink-0" />
        Criar Pasta
      </button>
    </PopoverContent>
  </Popover>
</template>
